<template>
	<div>
		<button :disabled="disabled" @click="click" class="btn btn-block btn-default pull-right">
			<i class="icon-solicitacao_nova_solicitacao"></i>
			<br />
			{{ capitalizaNome(_traducao('global', 'novo')) }}
		</button>
	</div>
</template>

<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	methods: {
		click() {
			this.$emit('click')
		},

		capitalizaNome(nome) {
			return nome
				.toLowerCase()
				.split(' ')
				.map((palavra) => palavra.charAt(0).toUpperCase() + palavra.substring(1))
				.join(' ')
		}
	}
}
</script>
